<div class="prf-footer-socials">
  @for (social of socials; track social.id) {
    <a class="footer-socials-item" [href]="social.href" target="_blank" (click)="onClickSocial(social.ymGoal)">
      <img [alt]="social.icon.alt" [src]="social.icon.src" [width]="social.icon.width" [height]="social.icon.height" />
    </a>
  }
</div>
